module.exports = __webpack_public_path__ + "static/media/crimpdle.22ec1c80.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/crimpdle.png
// module id = 106
// module chunks = 0